<template>
  <div>
    <!-- Sidebar visible -->
    <transition name="slide">
      <div v-if="newVisibleLeft" class="expanded-left-sidebar-div">
        <div
          class="vert-align left-sidebar-sub-item"
          :style="{
            'border-bottom: 1px solid var(--darkbackground)': isCommodity,
          }"
          @click="newVisibleLeft = false"
        ></div>
        <div
          v-for="(item, i) in itemsInformation"
          :key="i"
          class="vert-align position-relative"
          :class="getSidebarContainerElem(item)"
          :style="
            item.bdr ||
              (item.itemHeader &&
                'border-bottom: 1px solid var(--darkbackground);')
          "
          :id="getItemOpenChildren(item)"
          @mouseover="onHoverLeftSidebar(item.nameEvent)"
          @mouseleave="onHoverLeftSidebar('')"
        >
          <!-- Children -->
          <template v-if="item.children">
            <div
              @click.stop="onLeftSidebarAnalysis(item, $event, {}, true)"
              :class="getSidebarItemActive(item)"
            >
              {{ item.text }}
              <i
                :class="{
                  'pi pi-angle-right': !item.isOpen,
                  'pi pi-angle-down': item.isOpen,
                }"
                style="padding-left: 15px;"
              ></i>
            </div>

            <ul
              v-if="item.isOpen"
              :class="[
                getSidebarUlClass(item),
                { 'li-disabled': item.isDisabled },
              ]"
            >
              <!-- Input search -->
              <SearchInputCustom :isFiltered="item.isFiltered" :item="item" />

              <li
                v-for="(child, i) in item[
                  item.isFiltered ? 'filteredChildren' : 'children'
                ]"
                :key="i"
                :class="getSidebarItemClasses(child, item)"
                :id="getItemOpenMultiChildren(child)"
                @mouseover.stop="onHoverLeftSidebarSubItem(child, item)"
                @mouseleave.stop="onHoverLeftSidebarSubItem('')"
                @click.stop="onLeftSidebarAnalysis(child, $event, item)"
              >
                <div
                  class="list__line-conections"
                  v-if="isNonInteractiveElement(child)"
                ></div>
                <!-- Radio buttons-->
                <template
                  v-if="child.children && child.action === 'radio button'"
                >
                  <div
                    class="d-flex align-items-center container-elements"
                    :class="getSidebarSubItemActive(child, item)"
                  >
                    <input
                      type="radio"
                      name="radio"
                      :value="child.nameData"
                      @change="toggleList(child, $event, item, false)"
                      v-model="userInteractions.selectedItem"
                      class="radio-button"
                    />
                    {{ child.text }}
                    <i
                      :class="{
                        'pi pi-angle-right': !child.isOpen,
                        'pi pi-angle-down': child.isOpen,
                      }"
                      @click.stop="toggleList(child, $event, item, false)"
                    ></i>
                  </div>
                  <ul
                    v-if="child.isOpen"
                    :class="getSubItemOpenChildren(child)"
                  >
                    <li
                      v-for="(itemChild, i) in child.children"
                      :key="i"
                      :class="getSidebarItemClasses(itemChild, child)"
                      @mouseover="onHoverLeftSidebarSubItem(itemChild, child)"
                      @mouseleave="onHoverLeftSidebarSubItem('')"
                      @click.stop="
                        onLeftSidebarAnalysis(itemChild, $event, child)
                      "
                    >
                      <div
                        class="list__line-conections"
                        v-if="isNonInteractiveElement(itemChild)"
                      ></div>
                      <div
                        :class="{
                          'container-item__active':
                            itemChild[child.nameData] === child.childSelected,
                        }"
                      >
                        {{ itemChild[child.nameData] }}
                      </div>
                    </li>
                  </ul>
                </template>
                <!-- Button -->
                <template v-else-if="child.action === 'button'">
                  <button
                    @click.stop="onLeftSidebarAnalysis(child, $event)"
                    class="btn-apply"
                    :disabled="isBtnDeactivated"
                  >
                    {{ child.text }}
                  </button>
                </template>
                <!-- Children -->
                <template v-else-if="child.children">
                  <div
                    :class="getSidebarSubItemActive(child, item)"
                    @click.stop="toggleList(child, $event, item, true)"
                  >
                    {{ child.text }}
                    <i
                      :class="{
                        'pi pi-angle-right': !child.isOpen,
                        'pi pi-angle-down': child.isOpen,
                      }"
                      style="padding-left: 15px;"
                    ></i>
                  </div>
                  <ul
                    v-if="child.isOpen"
                    :class="getSubItemOpenChildren(child)"
                  >
                    <!-- Input search -->
                    <SearchInputCustom
                      :isFiltered="child.isFiltered"
                      :item="child"
                    />

                    <li
                      v-for="(itemChild, i) in child[
                        child.isFiltered ? 'filteredChildren' : 'children'
                      ]"
                      :key="i"
                      :class="getSidebarItemClasses(itemChild, item)"
                      @mouseover="onHoverLeftSidebarSubItem(child, item)"
                      @mouseleave="onHoverLeftSidebarSubItem('')"
                      @click.stop="
                        onLeftSidebarAnalysis(itemChild, $event, child)
                      "
                    >
                      <div
                        class="list__line-conections"
                        v-if="isNonInteractiveElement(itemChild)"
                      ></div>
                      <template v-if="itemChild.icon">
                        <!-- Icons de convert -->
                        <div
                          v-html="itemChild.icon"
                          :title="itemChild.nameHover"
                          :class="{
                            'container-item__active':
                              itemChild.id === child.childSelected,
                          }"
                        ></div>
                      </template>
                      <template v-else>
                        <div
                          :class="{
                            'container-item__active':
                              itemChild[child.nameData] === child.childSelected,
                          }"
                        >
                          {{ itemChild[child.nameData] }}
                        </div>
                      </template>
                    </li>
                  </ul>
                </template>
                <!-- No children -->
                <template v-else>
                  <div
                    :class="{
                      'container-item__active':
                        (child[item.nameData] &&
                          child[item.nameData] === item.childSelected) ||
                        child.text === item.childSelected,
                    }"
                  >
                    {{
                      capitalizeWords(
                        child[item.nameData]
                          ? child[item.nameData]
                          : child.text
                          ? child.text
                          : "",
                      )
                    }}
                  </div>
                  <!-- Inputs -->
                  <template v-if="child.action === 'input'">
                    <input
                      v-model.number="userInteractions[child.placeholder]"
                      :placeholder="child.placeholder"
                      class="custom-input"
                      @change="changeValueInputs(child)"
                    />
                  </template>
                </template>
              </li>
            </ul>
          </template>
          <!-- No children -->
          <template v-else>
            <template v-if="item.action === 'template'">
              <div
                v-html="item.dataInfo"
                class="sidebar__item-information"
                :class="{ 'sidebar__item-information_top': !isCommodity }"
              ></div>
            </template>
            <template v-else>
              <div
                @click="onLeftSidebarAnalysis(item, $event, {}, true)"
                @mouseover="onHoverLeftSidebar(item.nameEvent)"
                @mouseleave="onHoverLeftSidebar('')"
                :class="getSidebarContainerElem(item)"
                class="vert-align position-relative"
                style="padding-left: 0 !important;"
              >
                {{ item.text }}
              </div>
            </template>
          </template>
        </div>
      </div>
    </transition>
    <!-- Lateral sidebar -->
    <div class="left-sidebar-div">
      <div
        class="justify-content-center vert-align container-left-sidebar-item"
        style="
            border-bottom: 1px solid var(--darkbackground)"
      >
        <BurgerButton
          :isActive="newVisibleLeft"
          @eventOnUserClick="eventOnUserClick"
        ></BurgerButton>
      </div>
      <div
        v-for="(item, i) in itemsInformation"
        :key="i"
        class="justify-content-center vert-align"
        :class="getSidebarContent(item)"
        :style="item.bdr && 'border-bottom: 1px solid var(--darkbackground);'"
        @mouseover="onHoverLeftSidebar(item.nameEvent)"
        @mouseleave="onHoverLeftSidebar('')"
        @click="onLeftSidebarAnalysis(item, $event, {}, true)"
      >
        <template v-if="item.itemHeader">
          {{ item.classNameIcon }}
        </template>
        <template v-else-if="!item.classNameIcon">
          <component
            :is="item.icon"
            :colorHover="isHoverItem(item)"
          ></component>
        </template>
        <template v-else>
          <i
            :class="item.classNameIcon"
            style="font-size: 1.2rem!important;"
          ></i>
        </template>
        <transition name="appear">
          <div
            v-if="!newVisibleLeft && hoverVariable === item.nameEvent"
            class="vert-align left-sidebar-item-float"
            :style="getItemFloatStyles(item)"
          >
            {{ item.text }}
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import BurgerButton from "@/components/BurgerButton";
import InformationIcon from "@/assets/icons/Information.vue";
import CommoditiesIcon from "@/assets/icons/Commodity.vue";
import AnalysisIcon from "@/assets/icons/Analysis.vue";
import ContractIcon from "@/assets/icons/Contract.vue";
import CurrencyIcon from "@/assets/icons/Currency.vue";
import SearchInputCustom from "../Inputs/SearchInput.vue";

export default {
  name: "LeftSidebarMarkets",
  components: {
    BurgerButton,
    InformationIcon,
    CommoditiesIcon,
    AnalysisIcon,
    ContractIcon,
    CurrencyIcon,
    SearchInputCustom,
  },
  data() {
    return {
      userInteractions: {
        freight: 0,
        selectedItem: "continuous_contract",
        tariff: 0,
      },
      data: {
        pointerEvent: [],
      },
      settings: {
        defaultOperation: 0,
        screenHeight: 0,
      },
    };
  },
  props: {
    newVisibleLeft: { required: true, type: Boolean, default: false },
    hoverVariable: { required: true, type: String, default: "" },
    newSelectedAnalysis: { required: true, type: String, default: "" },
    hoverVariableSubItem: { required: true, type: String, default: "" },
    newSelectedAnalysisParent: { required: true, type: String, default: "" },
    isCommodity: { required: false, type: Boolean, default: false },
    itemsInformation: {
      type: Array,
      default: () => [
        {
          text: "",
          nameEvent: "",
          bdr: false,
          itemHeader: false,
          classNameIcon: "",
          bdrTransition: false,
        },
      ],
    },
  },
  mounted() {
    this.updateScreenHeight();
    this.syncRadioSelection();
  },
  watch: {
    newVisibleLeft(val) {
      if (!val) {
        this.getOpenElements();
      }
    },
    itemsInformation: {
      handler() {
        this.syncRadioSelection();
      },
      deep: true
    },
    hoverVariable: {
      handler() {},
      deep: true,
    },
  },
  computed: {
    isBtnDeactivated() {
      return this.settings.defaultOperation === 0;
    },
    isLargeScreen() {
      if (this.settings.screenHeight >= 800) {
        return "--xxl";
      } else if (this.settings.screenHeight >= 700) {
        return "";
      } else if (this.settings.screenHeight > 600) {
        return "--medium";
      } else {
        return "--small";
      }
    },
  },
  methods: {
    syncRadioSelection() {
      const contractItem = this.itemsInformation.find(
        item =>
          Array.isArray(item.children) &&
          item.children.some(child => child.action === "radio button")
      );
      if (!contractItem) return;
      const radios = contractItem.children.filter(
        child => child.action === "radio button"
      );
      const active = radios.find(
        child => child.childSelected != null && child.childSelected !== ""
      );
      if (active && this.userInteractions.selectedItem !== active.nameData) {
        this.userInteractions.selectedItem = active.nameData;
      }
    },
    // Setting data
    isNonInteractiveElement(child) {
      return (
        child &&
        !child?.children &&
        child?.action !== "input" &&
        child?.action !== "button"
      );
    },
    isFilteredItem(item) {
      if (item.isFiltered) {
        this.onCleanInputSearch(item);
      }
    },
    updateScreenHeight() {
      this.settings.screenHeight = window.innerHeight;
    },
    removeNameEvent(nameEvent) {
      if (nameEvent.includes("eventOnClientSelect")) {
        return "eventOnClientSelect";
      } else return nameEvent;
    },
    // User interactions
    onHoverLeftSidebar(val) {
      this.$emit("onHoverLeftSidebar", val);
    },
    toggleList(val, event, item, multipleOpen) {
      this.data.pointerEvent.push(event && val.isOpen ? event : "");
      if (item?.itemHeader) return;
      if (item?.children) {
        const eventVal = val.nameEvent;
        // Parent Index
        const findIndex = this.itemsInformation.findIndex(
          (d) => d.text === item.text,
        );
        // Children Index
        const childIndex = this.itemsInformation[findIndex].children.findIndex(
          (d) => d.text === val.text,
        );
        // Close open subitems other than the one you clicked on
        if (!multipleOpen) {
          this.itemsInformation.forEach((parentItem, parentIndex) => {
            if (parentIndex === findIndex) {
              parentItem.children.forEach((item, index) => {
                if (index !== childIndex) {
                  this.$set(parentItem.children, index, {
                    ...item,
                    isOpen: false,
                  });
                }
              });
            }
          });
        }

        // Open/close the clicked subitem
        this.$set(this.itemsInformation[findIndex].children, childIndex, {
          ...this.itemsInformation[findIndex].children[childIndex],
          isOpen: !this.itemsInformation[findIndex].children[childIndex].isOpen,
        });

        const getEvent = this.data.pointerEvent.findLast((d) => d !== "");
        this.$emit("onLeftSidebarAnalysisScenarios", {
          getEvent: getEvent,
          nameEvent: eventVal,
        });
        if (this.isEventTargetRotated(event)) {
          this.eventOnUserClick();
          if (!this.newVisibleLeft && !val.isOpen) {
            this.$set(this.itemsInformation[findIndex].children, childIndex, {
              ...this.itemsInformation[findIndex].children[childIndex],
              isOpen: true,
            });
          }
        }
      } else if (!item.multipleOpen && !val?.multipleOpen) {
        this.$emit("onLeftSidebarAnalysis", {
          val: val.nameEvent,
          parent: val?.nameEventParent,
        });
      }
      if (val.action === "radio button") {
        const objChildren = val.children[0];
        this.onClickInElements(objChildren, event, val);
      }
    },
    onHoverLeftSidebarSubItem(item, parentItem) {
      const isText = item[parentItem?.nameData]
        ? item[parentItem.nameData]
        : item?.nameHover
        ? item?.nameHover
        : item.text
        ? item.text
        : "";
      this.$emit("onHoverLeftSidebarSubItem", isText.toString());
    },
    onLeftSidebarAnalysis(val, event, item = {}, isParent = false) {
      if (val.action !== "template") {
        this.data.pointerEvent.push(event && val.isOpen ? event : "");
        this.onClickInElements(val, event, item);

        const findIndex = this.itemsInformation.findIndex(
          (d) => d.text === val.text,
        );

        if (val.itemHeader) return;

        // Close all information items except the one currently selected
        const filterItemsInfo = this.itemsInformation.filter(
          (d) => d.isOpen && isParent && d.text !== val.text,
        );
        if (filterItemsInfo) {
          filterItemsInfo.forEach((d) => {
            d.isOpen = false;
            if (d.children && Array.isArray(d.children)) {
              d.children.forEach((child) => {
                child.isOpen = false;
                this.isFilteredItem(child);
                if (child.children) {
                  child.children.forEach((chil) => {
                    chil.isOpen = false;
                    this.isFilteredItem(chil);
                  });
                }
              });
            }
            this.isFilteredItem(d);
          });
        }

        // Handle clicks on items with children
        if (val.children) {
          const eventVal = val.nameEvent ? val.nameEvent : item.nameEvent;
          if (findIndex !== -1) {
            const updateIsOpen =
              !val.isOpen && (!this.newVisibleLeft || !val.isOpen);

            // Update the specific item in the array
            this.$set(this.itemsInformation, findIndex, {
              ...this.itemsInformation[findIndex],
              isOpen: updateIsOpen,
            });
            if (!this.newVisibleLeft) {
              this.eventOnUserClick();
            }
          }

          const getEvent = this.data.pointerEvent.findLast((d) => d !== "");
          this.$emit("onLeftSidebarAnalysisScenarios", {
            getEvent: getEvent,
            nameEvent: eventVal,
          });
          if (this.isEventTargetRotated(event)) {
            this.eventOnUserClick();
            if (!this.newVisibleLeft && !val.isOpen) {
              if (findIndex !== -1) {
                this.$set(this.itemsInformation, findIndex, {
                  ...this.itemsInformation[findIndex],
                  isOpen: true,
                });
              }
            }
          }
        } else if (!item.multipleOpen && !val?.multipleOpen) {
          this.$emit("onLeftSidebarAnalysis", {
            val: val.nameEvent,
            parent: val?.nameEventParent,
          });
          setTimeout(() => {
            this.getOpenElements();
          }, 500);
        }
      } else if (!this.newVisibleLeft) {
        this.eventOnUserClick();
      }
    },
    // Clean the search filter
    onCleanInputSearch(item) {
      item.filteredChildren = item.children;
    },
    onClickInElements(item, event, parentItem) {
      let nameEvent = item.nameEvent ? item.nameEvent : parentItem.nameEvent;
      nameEvent = this.removeNameEvent(nameEvent);
      const className = event.target.className;
      if (
        typeof className === "string" &&
        !className.includes("pi pi-angle-") &&
        !className.includes("p-inputtext") &&
        item.action !== "radio button"
      ) {
        this.$emit(nameEvent, {
          item,
          nameEvent,
        });
        if (parentItem.action === "radio button") {
          Object.assign(this.userInteractions, {
            selectedItem: parentItem.nameData,
          });
        }
      }
      if (item.action === "radio button" && className === "radio-button") {
        this.eventOnUserClick();
      }
      if (nameEvent === "onSelectedOperation") {
        Object.assign(this.settings, {
          defaultOperation: item.id,
        });
      }
      if (nameEvent === "onUserCommoditySelection" && !item.children) {
        Object.assign(this.userInteractions, {
          selectedItem: "continuous_contract",
        });
      }
    },
    isEventTargetRotated(event) {
      return event.target.parentElement === "svg#commodities__icon";
    },
    eventOnUserClick() {
      this.$emit("eventOnUserClick");
    },
    getOpenElements() {
      // Check if all elements are closed
      const isEveryClose = !this.itemsInformation.every((d) => {
        if (d.children && Array.isArray(d.children)) {
          return d.children.some((child) => child.isOpen);
        }
        return d.isOpen;
      });

      // Close all elements
      if (!this.newVisibleLeft && isEveryClose) {
        this.itemsInformation.forEach((item) => {
          item.isOpen = false;

          if (item.children) {
            this.setChildrenOpenToFalse(item.children);
          }
        });
        // Remove any hover
        this.$emit("onHoverLeftSidebar", "");
      }
    },
    setChildrenOpenToFalse(children) {
      if (Array.isArray(children)) {
        children.forEach((child) => {
          child.isOpen = false;
          if (child.children) {
            this.setChildrenOpenToFalse(child.children);
          }
        });
      } else if (typeof children === "object" && children !== null) {
        Object.values(children).forEach((child) => {
          child.isOpen = false;
          if (child.children) {
            this.setChildrenOpenToFalse(child.children);
          }
        });
      }
    },
    changeValueInputs(item) {
      const nameEvent = item.nameEvent;
      this.$emit(nameEvent, {
        item,
        valueInput: this.userInteractions[item.placeholder],
      });
    },
    isHovered(nameEvent) {
      return this.hoverVariable === nameEvent;
    },
    isHoveredSubItem(nameEvent) {
      return this.hoverVariableSubItem === nameEvent;
    },
    isSelectedAnalysis(nameEvent) {
      return this.newSelectedAnalysis === nameEvent;
    },
    isSelectedAnalysisParent(nameEvent) {
      return this.newSelectedAnalysisParent === nameEvent;
    },
    isLargeScreenAndLargeItems(item) {
      let value = "";
      if (
        item.children &&
        (item.children.length >= 12 ||
          Object.keys(item.children).length >= 12) &&
        !item.isStyleGrid
      ) {
        value = this.isLargeScreen;
      } else if (this.isLargeScreen === "--xxl" && !item.isStyleGrid) {
        value = "--medium";
      } else if (item.isStyleGrid) {
        value = this.getSidebarItemGrid(item);
      } else {
        value = this.isLargeScreen;
      }
      return value;
    },
    // Configuration Styles
    getSidebarItemActive(item) {
      return [
        item.itemHeader
          ? ""
          : this.isHovered(item.nameEvent) ||
            this.isSelectedAnalysis(item.nameEvent) ||
            this.isSelectedAnalysisParent(item.nameEvent)
          ? "leftSidebarActive"
          : "",
      ];
    },
    getSidebarContent(item) {
      let className = "";
      const allChildrenClosed =
        Array.isArray(item?.children) &&
        item?.children.every(
          (d) =>
            Object.prototype.hasOwnProperty.call(d, "isOpen") &&
            !d?.isOpen &&
            item.children.length < 5,
        );

      if (item?.children && item.isOpen && allChildrenClosed) {
        return "item-content-open-sub-item-close"; // 125px
      } else if (item.isOpen) {
        className = `container-item-content-open item-content-open${this.isLargeScreenAndLargeItems(
          item,
        )}`; // 345px
      } else {
        className = "container-left-sidebar-item"; // 45px
      }
      return [this.getSidebarItemActive(item), className];
    },
    getSidebarSubItemActive(item, parentItem) {
      const isText = item[parentItem?.nameData]
        ? item[parentItem.nameData]
        : item?.nameHover
        ? item?.nameHover
        : item.text
        ? item.text
        : "";
      return [this.isHoveredSubItem(isText) ? "leftSidebarActive" : ""];
    },
    getSidebarItemButton(item) {
      if (item.action === "button") {
        return "sidebar-item-li__button";
      }
    },
    getSidebarLineConections(item) {
      if (this.isNonInteractiveElement(item)) {
        return "position-relative d-flex align-items-center list__line-vertical";
      }
    },
    getSidebarItemClasses(item, parentItem = {}) {
      const isItem = item ? item : parentItem;
      return [
        this.getSidebarSubItemActive(isItem, parentItem),
        this.getSidebarItemActive(isItem),
        this.getSidebarSubItemInputs(isItem),
        this.getSidebarItemButton(isItem),
        this.getSidebarLineConections(isItem),
        {
          "left-sidebar-sub-item": !isItem.itemHeader,
          "left-sidebar-sub-item-xs":
            !isItem.itemHeader &&
            parentItem.children &&
            (parentItem.children.length >= 4 ||
              Object.keys(parentItem.children).length >= 4),
          "left-sidebar-item": isItem.itemHeader,
        },
      ];
    },
    getSidebarContainerElem(item) {
      return [
        this.getSidebarItemActive(item),
        {
          "left-sidebar-sub-item": !item.itemHeader,
        },
      ];
    },
    getSidebarItemGrid(item) {
      if (item.children && item.isStyleGrid) {
        const isEveryClose = item.children.every((d) => !d.isOpen);

        let isOpenChildren = false;
        if (item.isParent) {
          item.children.forEach((d) => {
            if (d.children && d.isOpen && d.children.length >= 7) {
              isOpenChildren = this.isLargeScreen;
            } else if (d.children && d.isOpen && d.children.length <= 6) {
              isOpenChildren = "--medium";
              if (this.settings.screenHeight < 600) isOpenChildren = "--small";
            } else if (item.isOpen && isEveryClose) {
              isOpenChildren = "--small";
            }
          });
        } else if (item.children && item.isOpen) {
          if (item.children.length >= 7) {
            isOpenChildren = "--xxl";
            if (this.settings.screenHeight < 700) isOpenChildren = "--small";
          } else if (item.children.length <= 6) {
            isOpenChildren = "--small";
          }
        }

        return isOpenChildren;
      }
    },
    getSidebarUlClass(item) {
      let className = "container-left-sidebar-ul left-sidebar-ul";
      return [
        this.getSidebarChildrenGrid(item),
        this.getSidebarUlLeft(item),
        this.getSidebarItemGrid(item),
        {
          [`${className}${this.isLargeScreenAndLargeItems(item)}`]:
            item?.children && !item.isStyleGrid,
          [`${className}${this.getSidebarItemGrid(item)}`]:
            item?.children && item.isStyleGrid,
        },
      ];
    },
    getSidebarUlRelative(item) {
      return [
        {
          "left-sidebar-ul__relative": item?.children,
        },
      ];
    },
    getItemFloatStyles(item) {
      return {
        color: item.itemHeader && "var(--textinactive)",
        "border-bottom":
          item.bdr ||
          item.itemHeader ||
          (item.bdrTransition && "1px solid var(--darkbackground)"),
      };
    },
    getItemOpenChildren(item) {
      if (item?.children && item.isOpen) {
        const allChildrenClosed =
          Array.isArray(item.children) &&
          item.children.every(
            (d) =>
              Object.prototype.hasOwnProperty.call(d, "isOpen") &&
              !d.isOpen &&
              item.children.length < 5,
          );

        if (allChildrenClosed) {
          return "sub-item--close__children";
        } else {
          return `sub-item__children${this.isLargeScreenAndLargeItems(item)}`;
        }
      }
    },
    getItemOpenMultiChildren(child) {
      if (child?.children && child.children.length > 1 && child.isOpen) {
        return `sub-item__multi-children${this.isLargeScreenAndLargeItems(
          child,
        )}`;
      }
    },
    getSubItemOpenChildren(child) {
      const styleNames = [];
      if (child.children && child.children.length > 1) {
        styleNames.push(
          this.getSidebarUlRelative(child),
          `container-sub-sub-item__children sub-sub-item__children${this.isLargeScreenAndLargeItems(
            child,
          )}`,
        );
      }
      return styleNames;
    },
    getSidebarChildrenGrid(child) {
      if (child.isStyleGrid) {
        return "sub-sub-item__children--grid";
      }
    },
    getSidebarSubItemInputs(child) {
      if (child.action === "input") {
        return "sub-sub-item__children--inputs";
      }
    },
    getSidebarUlLeft(child) {
      return [
        {
          "left-sidebar-ul__left": child?.children,
        },
      ];
    },
    isHoverItem(item) {
      return item.itemHeader
        ? ""
        : this.isHovered(item.nameEvent) ||
          this.isSelectedAnalysis(item.nameEvent) ||
          this.isSelectedAnalysisParent(item.nameEvent)
        ? "var(--symmetry-h)"
        : "var(--textinactive)";
    },
    capitalizeWords(value) {
      if (!value) return "";

      const uppercaseWords = new Set([
        "c&f",
        "cad",
        "cfr",
        "cif",
        "cpo",
        "dap",
        "dce",
        "eu",
        "fob",
        "hrc",
        "hrs",
        "hrw",
        "iii",
        "lme",
        "map",
        "mb",
        "me",
        "myr",
        "na",
        "nfd",
        "pko",
        "rbd",
        "sfo",
        "srw",
        "uan",
        "uk",
        "usa",
        "usd",
        "usgc",
        "wti",
      ]);

      return String(value)
        .split(/\s+/)
        .map((word) => {
          // Separa puntuación al final (opcional)
          const match = word.match(/^([A-Za-z]+)(.*)$/);

          if (!match) return word;

          const [, text, suffix] = match;

          if (uppercaseWords.has(text.toLowerCase())) {
            return text.toUpperCase() + suffix;
          }

          return text.charAt(0).toUpperCase() + text.slice(1) + suffix;
        })
        .join(" ");
    },
  },
};
</script>

<style scoped>
ul {
  position: absolute;
  top: 36px;
  left: 75px;
}
ul:not(.leftSidebarActive) {
  color: var(--textinactive);
}
.hovered-item {
  color: var(--textactive);
}
.selectActive {
  color: var(--textactive);
}
.slide-enter-active,
.slide-leave-active {
  transition: transform 0.2s ease;
}
.slide-enter,
.slide-leave-to {
  transform: translateX(-100%);
  transition: all 150ms ease-in 0s;
}
.appear-enter-active,
.appear-leave-active {
  transition: opacity 0.5s ease;
}
.appear-enter,
.appear-leave-to {
  opacity: 0;
  transition: all 500ms ease-in 0s;
}
.container-left-sidebar-ul {
  height: 100%;
  overflow-y: auto;
  margin-top: 8px;
  min-width: 212px;
}
.left-sidebar-ul {
  max-height: 300px;
}
.left-sidebar-ul--medium {
  max-height: 260px;
}
.left-sidebar-ul--small {
  max-height: 180px;
}
.left-sidebar-ul--xl {
  max-height: 350px;
}
.left-sidebar-ul--xxl {
  max-height: 410px;
}
.left-sidebar-ul__relative {
  position: relative;
  left: auto;
  top: auto;
}
.custom-input {
  width: 60%;
  height: 60%;
}
.left-sidebar-ul__left {
  left: auto;
}
input[type="radio"] {
  display: inline-block;
  -webkit-appearance: none;
  -moz-appearance: none;
  -o-appearance: none;
  appearance: none;
  border-radius: 1em;
  border: 4px solid var(--lightbackground4);
  width: 16px;
  height: 16px;
  background: var(--lightbackground4);
}

input[type="radio"]:checked {
  background: var(--expo);
}
@media (max-height: 700px) {
  .container-left-sidebar-ul {
    margin-top: 5px;
  }
}
</style>
